import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";

export const Author = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="autor"
      ref={ref}
      className="relative overflow-hidden bg-[#141c28] py-28 sm:py-36"
      data-testid="author-section"
    >
      {/* nádech soumraku z fotografie */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-navy-deep to-transparent"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-[radial-gradient(70%_100%_at_50%_0%,rgba(201,127,82,0.12),transparent_70%)]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-56 bg-[radial-gradient(70%_100%_at_50%_100%,rgba(217,123,72,0.10),transparent_70%)]"
      />
      <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute -left-4 -top-4 h-full w-full rounded-sm border border-copper/30"
              />
              <div className="relative overflow-hidden rounded-sm">
                <motion.img
                  style={{ y: imgY }}
                  src="/assets/author-silhouette.webp"
                  srcSet="/assets/author-silhouette-768.webp 768w, /assets/author-silhouette.webp 1152w"
                  sizes="(max-width: 1024px) 100vw, 40vw"
                  width={1152}
                  height={1536}
                  loading="lazy"
                  alt="Autor e-booku Proměna muže – silueta při západu slunce u horského jezera"
                  className="block w-full scale-110 object-cover"
                  data-testid="author-photo"
                />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-8">
          <Reveal>
            <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-copper">
              <span className="h-px w-10 bg-copper/60" aria-hidden="true" />
              Proč tahle kniha vznikla
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-tight text-cream sm:text-5xl">
              Nenapsal jsem ji jako někdo,
              <br />
              kdo má život <span className="italic text-copper">vyřešený</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-cream/70 sm:text-lg">
              <p>
                Vznikla z let, kdy jsem se snažil pochopit ženy, vztahy – ale postupně hlavně sám
                sebe. Z vlastních zkušeností, chyb, odmítnutí i vztahů. Z období, kdy jsem hledal
                odpovědi v knihách, přemýšlel nad tím, proč některé věci opakuju, a postupně
                zjišťoval, že otázka není jen: <em className="text-cream">Jak být úspěšnější u žen?</em>
              </p>
              <p>
                Mnohem důležitější byla jiná:{" "}
                <em className="text-cream">Jakým mužem se vlastně chci stát?</em>
              </p>
              <p>
                Z toho nakonec vzniklo 40 principů lepšího muže. Ne jako absolutní pravdy. Ale jako
                výběr myšlenek, ke kterým bych se chtěl vracet i já sám – a které mohou pomoct
                dalším mužům zastavit se a podívat se na svůj život trochu jinak.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 border-l-2 border-copper/60 pl-6">
              <p className="font-serif text-2xl italic text-cream">Proměna muže</p>
              <p className="mt-2 text-sm leading-relaxed text-cream/50">
                autor e-booku 40 principů lepšího muže
                <br />
                promenamuze.cz
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
